module.exports = __webpack_public_path__ + "static/media/botanicalSnakePlant.21c581a4.jpg";